import { styled } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const _excluded = ["theme"];
const RowDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  // @ts-ignore
  const {
    spacingSize
  } = props;
  const spacing = spacingSize ? theme.spacing[spacingSize] : theme.grid.gutterWidth;
  return _objectSpread2({
    boxSizing: 'border-box',
    display: 'flex',
    flex: '0 1 auto',
    flexDirection: 'row',
    flexWrap: 'wrap',
    mr: `-${spacing}px`,
    ml: `-${spacing}px`
  }, props);
})``;
RowDiv.displayName = 'RowDiv';

const _excluded$1 = ["children", "styles"];
function Row(_ref) {
  let {
      children,
      styles = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/createElement(RowDiv, _extends({}, props, styles.root), children);
}

export default Row;
